import { i18n } from "@/setup/i18n-setup";
import { v4 } from "uuid";

export class CustomButton {
	uid: string = v4();
	ID: number = 0;
	Name: string = i18n.t("components.view-editor.custom-buttons.new-button").toString();
	Url: string = "";
	Title: string = "";
	Icon: string = "external-link-alt";
	AdminOnly: boolean = false;
	IntegrateInBrowse: boolean = false;
	IframePosition: string = "right";
	IframeWidthMode: number = 0;
	IframeFixedWidth: number = 400;
	IframePercentWidth: number = 30;
	UseDesktopAppAsProxy: boolean = false;

	public constructor(data?: any) {
		if (!data) return;
		this.ID = data.ID || 0;
		this.Name = data.Name;
		this.Url = data.Url;
		this.Title = data.Title;
		this.Icon = data.Icon || "external-link-alt";
		this.AdminOnly = data.AdminOnly || false;
		this.IntegrateInBrowse = data.IntegrateInBrowse || false;
		this.IframePosition = data.IframePosition || "right";
		this.IframeWidthMode = data.IframeWidthMode || 0;
		this.IframeFixedWidth = data.IframeFixedWidth || 400;
		this.IframePercentWidth = data.IframePercentWidth || 30;
		this.UseDesktopAppAsProxy = data.UseDesktopAppAsProxy || false;
	}

	public getJSON() {
		return {
			ID: this.ID,
			Name: this.Name,
			Url: this.Url,
			Title: this.Title,
			Icon: this.Icon,
			AdminOnly: this.AdminOnly,
			IntegrateInBrowse: this.IntegrateInBrowse,
			IframePosition: this.IframePosition,
			IframeWidthMode: this.IframeWidthMode,
			IframeFixedWidth: this.IframeFixedWidth,
			IframePercentWidth: this.IframePercentWidth,
			UseDesktopAppAsProxy: this.UseDesktopAppAsProxy
		};
	}
}
